/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { MockSavingsManager } from "../MockSavingsManager";

export class MockSavingsManager__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(_save: string, overrides?: Overrides): Promise<MockSavingsManager> {
    return super.deploy(_save, overrides || {}) as Promise<MockSavingsManager>;
  }
  getDeployTransaction(
    _save: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(_save, overrides || {});
  }
  attach(address: string): MockSavingsManager {
    return super.attach(address) as MockSavingsManager;
  }
  connect(signer: Signer): MockSavingsManager__factory {
    return super.connect(signer) as MockSavingsManager__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MockSavingsManager {
    return new Contract(address, _abi, signerOrProvider) as MockSavingsManager;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_save",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_mAsset",
        type: "address",
      },
    ],
    name: "collectAndDistributeInterest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "save",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
